export const getProviderIcon = (type, providerType = 'cloud') => {
  if (!type) return null;
  
  switch (type?.toLowerCase()) {
    // Cloud Providers
    case 'aws':
    case 'amazon':
      return { icon: 'logos:aws', color: '#FF9900' };
    case 'azure':
      return { icon: 'logos:microsoft-azure', color: '#008AD7' };
    case 'googlecloud':
    case 'google cloud':
    case 'google':
      return { icon: 'logos:google-cloud', color: '#4285F4' };
    case 'oracle':
      return { icon: 'logos:oracle', color: '#C74634' };
    case 'leaseweb':
      return { icon: 'simple-icons:leaseweb', color: '#F76B0E' };
    case 'gcore':
      return { icon: 'simple-icons:gcore', color: '#00A0E5' };

    // CDN Providers
    case 'cloudfront':
      return { icon: 'logos:aws', color: '#FF9900' }; // AWS service
    case 'fastly':
      return { icon: 'simple-icons:fastly', color: '#FF282D' };
    case 'stackpath':
      return { icon: 'simple-icons:stackpath', color: '#00A3F3' };
    case 'gocache':
      return { icon: 'mdi:cloud-sync', color: '#4CAF50' };
    case 'edgecast':
      return { icon: 'mdi:cloud-sync', color: '#2196F3' };
    case 'akamai':
      return { icon: 'simple-icons:akamai', color: '#0096D6' };

    // WAF/Security Providers
    case 'cloudflare':
      return { icon: 'logos:cloudflare', color: '#F38020' };
    case 'incapsula':
      return { icon: 'simple-icons:imperva', color: '#E62B2B' };
    case 'sucuri':
      return { icon: 'mdi:shield-check', color: '#00B4E1' };
    case 'zscaler':
      return { icon: 'simple-icons:zscaler', color: '#FF5A00' };
    case 'office365':
      return { icon: 'logos:microsoft-office', color: '#D83B01' };

    default:
      return { icon: null, color: '#1A2027' };
  }
};

export const getProviderTypeColor = (providerType) => {
  switch (providerType?.toLowerCase()) {
    case 'cloud':
      return 'primary';
    case 'cdn':
      return 'info';
    case 'waf':
      return 'warning';
    default:
      return 'default';
  }
}; 